import { defineStore } from 'pinia'
import { useAuth } from '@/composables/useAuth'
import { ref } from 'vue'

export const useAuthStore = defineStore('auth', () => {
  const auth = useAuth()
  const initialized = ref(false)

  async function init() {
    if (!initialized.value) {
      await auth.checkLogin()
      initialized.value = true
    }
  }

  return {
    ...auth,
    init,
  }
})